import React from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from "@mui/material";
import { translate } from '../../i18n/customI18nProvider';

export function ChangeQuantityModal({ quantity, open, onClose, onConfirm, round }) {
  const [inputQuantity, setInputQuantity] = React.useState(quantity || 0);
  const inputRef = React.useRef(null);

  React.useEffect(() => {
    setInputQuantity(quantity || 0);
  }, [quantity, open]);

  const handleConfirm = () => {
    const quantityNumber = Number(inputQuantity);
    if (isNaN(quantityNumber) || quantityNumber < 0) return;

    let roundedQuantity = quantityNumber;
    if (round) {
      roundedQuantity = Math.round(quantityNumber / round) * round;
      roundedQuantity = Math.round(roundedQuantity * 100) / 100; // Round to 2 decimals to avoid floating point issues
    }

    onConfirm(roundedQuantity);
  };

  return (
    <Dialog
      fullWidth
      open={open}
      onClose={onClose}
      PaperProps={{ sx: { position: "absolute", top: 16, m: 0 } }}
      TransitionProps={{
        onEntered: () => {
          inputRef.current?.select();
        },
      }}
    >
      <DialogTitle>{translate('custom.enter_quantity')}</DialogTitle>
      <DialogContent>
        <TextField
          inputRef={inputRef}
          autoFocus
          margin="dense"
          label={translate('custom.quantity')}
          type="text"
          inputProps={{
            inputMode: round === 1 ? "numeric" : "decimal",
            pattern: "[0-9]*",
          }}
          fullWidth
          value={inputQuantity}
          onChange={(e) => setInputQuantity(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{translate('custom.cancel')}</Button>
        <Button
          onClick={handleConfirm}
          disabled={inputQuantity === ""}
          variant="contained"
        >
          {translate('custom.confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}